import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import './ktempleNav.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function KtempleNav() {
  return (
    <Navbar expand="lg" className="bg-body-tertiary">
      <Container>
        <Navbar.Brand href="/" className="text-center mx-auto d-flex flex-column align-items-center">
        <img
            src="/images/logo.svg" // Replace with the actual path to your logo
            alt="Krishna Temple Logo"
            width="120" // Adjust width as needed
            height="30" // Adjust height as needed
            className="logo img-fluid mb-2" // Add any additional classes you need
          />
          <div className='mt-2 text-center'>Krishna Temple Milwaukee</div>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link href="/">Home</Nav.Link>
            <Nav.Link href="/about-krishna-temple"><strong>Temple</strong></Nav.Link>
            <Nav.Link href="/krishna-temple-events"><strong>Events</strong></Nav.Link>
            <Nav.Link href="/krishna-temple-gallery"><strong>Gallery</strong></Nav.Link>
            <Nav.Link href="/radha-madhav-kitchen"><strong>Radha Madhav Kitchen</strong></Nav.Link>
            <Nav.Link href="/donate"><strong>Donate</strong></Nav.Link>
            <Nav.Link href="/krishna-temple-contact">Contact</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default KtempleNav;